<template>
  <div class="container z-depth-1 mt-5 p-lg-5">
    <!-- Section -->
    <section class="provider-body">
      <h2 class="font-weight-bold text-center section-title pb-2">
        Comment ça marche pour les livreurs&nbsp;?
      </h2>
      <hr class="w-header my-4" />
      <p class="lead text-center section-lead pt-2 mb-5">
        En quelques étapes, vous connectez votre
        <strong>activité de transport</strong> au réseau Livratos&nbsp;: vous
        créez votre compte, nos équipes valident votre profil, vous acceptez des
        courses et vous êtes payé régulièrement.
      </p>

      <div class="row d-flex justify-content-center px-3">
        <!-- Étape 1 : Inscription -->
        <div class="col-md-6 col-xl-4 slide-left">
          <div class="step-label step-1">
            <h3 class="font-weight-normal service-title">
              1. Inscription en ligne
            </h3>
            <p class="small service-tag">
              Création de votre profil <strong>livreur</strong>
            </p>
          </div>
        </div>

        <div class="col-md-6 slide-right">
          <div class="step-panel step-1">
            <p class="service-text mb-5 pb-2">
              Vous créez votre compte <strong>livreur</strong> en quelques
              minutes&nbsp;: <strong>coordonnées</strong>, type de structure
              (indépendant ou société), <strong>type(s) de véhicule</strong>,
              zones d’intervention et documents nécessaires (permis, carte
              grise, Kbis, rib... ). Votre demande arrive ensuite à notre équipe
              de validation.
            </p>
          </div>
        </div>

        <!-- Étape 2 : Activation du compte -->
        <div class="col-md-6 col-xl-4 slide-left">
          <div class="step-label step-2">
            <h3 class="font-weight-normal service-title">
              2. Validation & activation
            </h3>
            <p class="small service-tag">Contrôle & paramétrage du profil</p>
          </div>
        </div>

        <div class="col-md-6 slide-right">
          <div class="step-panel step-2">
            <p class="service-text mb-5 pb-2">
              Nos équipes vérifient vos pièces et vous contactent pour un
              échange de validation. Cet appel nous permet de vérifier votre
              identité, de confirmer votre véhicule, et de nous assurer que vous
              maîtrisez les règles de sécurité liées aux livraisons BTP. Une
              fois validé, votre compte passe en statut actif et vous pouvez
              commencer à recevoir des propositions de courses.
            </p>
          </div>
        </div>

        <!-- Étape 3 : Prise de courses -->
        <div class="col-md-6 col-xl-4 slide-left">
          <div class="step-label step-3">
            <h3 class="font-weight-normal service-title">
              3. Acceptez vos livraisons
            </h3>
            <p class="small service-tag">Express & programmées</p>
          </div>
        </div>

        <div class="col-md-6 slide-right">
          <div class="step-panel step-3">
            <p class="service-text mb-5 pb-2">
              Depuis votre interface Livratos (web ou mobile), vous voyez les
              <strong>courses disponibles</strong> correspondant à votre
              véhicule et à votre zone. Vous choisissez celles qui vous
              intéressent&nbsp;: enlèvement en dépôt, adresse
              <strong>chantier</strong>, créneau, type de chargement et
              consignes sont indiqués avant d’accepter. Vous suivez ensuite
              chaque mission jusqu’à la remise sur site.
            </p>
          </div>
        </div>

        <!-- Étape 4 : Paiement -->
        <div class="col-md-6 col-xl-4 slide-left">
          <div class="step-label step-4">
            <h3 class="font-weight-normal service-title">
              4. Paiements regroupés
            </h3>
            <p class="small service-tag">Courses tracées, revenus lisibles</p>
          </div>
        </div>

        <div class="col-md-6 slide-right">
          <div class="step-panel step-4">
            <p class="service-text mb-5 pb-2">
              Toutes les courses réalisées via Livratos sont enregistrées et
              tracées dans votre espace
              <strong>livreur</strong>. Vos revenus sont regroupés sur des
              périodes définies (8&nbsp;jours), avec un récapitulatif clair de
              chaque mission. Vous êtes ensuite payé sur le compte indiqué, sans
              avoir à gérer des encaissements au cas par cas.
            </p>
          </div>
        </div>
      </div>
    </section>
    <!-- Section -->
  </div>
</template>

<script>
export default {
  name: "ProviderBodyLivreur",
};
</script>

<style lang="scss" scoped>
.provider-body {
  .section-title {
    color: $color-text;
  }

  .section-lead {
    color: $color-text-grey;
    font-size: 1.05rem;
  }

  /* Bloc titre + tag */
  .step-label {
    padding: 1.4rem 1.6rem;
    border-radius: 10px;
    margin-bottom: 1rem;
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);
  }

  /* panneaux texte */
  .step-panel {
    padding: 1.1rem 1.4rem;
    border-radius: 10px;
    margin-bottom: 1.5rem;
    background-color: $background;
    border-left: 3px solid transparent;
  }

  .service-title {
    margin: 0;
    font-size: 1.2rem;
  }

  .service-tag {
    margin: 0.4rem 0 0;
    font-size: 0.85rem;
    font-weight: 600;
  }

  .service-text {
    color: $color-text-grey;
    font-size: 0.98rem;
    line-height: 1.6;
    margin: 0;
  }

  /* Alternance vert / noir */

  /* Étape 1 & 3 : fond vert */
  .step-1.step-label,
  .step-3.step-label {
    background-color: $color-primary;
    .service-title {
      color: #000;
    }
    .service-tag {
      color: #000;
      opacity: 0.85;
    }
  }

  .step-1.step-panel,
  .step-3.step-panel {
    border-left-color: $color-primary;
  }

  /* Étape 2 & 4 : fond noir */
  .step-2.step-label,
  .step-4.step-label {
    background-color: #000;
    .service-title {
      color: $color-primary;
    }
    .service-tag {
      color: #ffffff;
      opacity: 0.85;
    }
  }

  .step-2.step-panel,
  .step-4.step-panel {
    border-left-color: #000;
  }

  @media (max-width: 767.98px) {
    .step-label {
      text-align: left;
    }
    .section-lead {
      font-size: 1rem;
    }
  }
}
</style>
